module.exports = __webpack_public_path__ + "static/media/electron.efc72692.svg";